import { Star, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

const DEFAULT_ITEMS = [
  "KHASIM TRENDZ",
  "PREMIUM MENSWEAR",
  "BUTTAIPET • MACHILIPATNAM",
  "BUY ON WHATSAPP",
  "NEW DROPS WEEKLY",
  "STREETWEAR • FORMAL • ACCESSORIES",
];

export default function Marquee() {
  const [items, setItems] = useState(DEFAULT_ITEMS);

  useEffect(() => {
    supabase.storage.from("images").download("settings/marquee.json").then(({ data, error }) => {
      if (!error && data) {
        data.text().then(text => {
          try {
            setItems(JSON.parse(text));
          } catch (e) {}
        });
      }
    });
  }, []);

  // Duplicate items for seamless loop
  const loop = items.length > 0 ? [...items, ...items, ...items] : [];

  if (loop.length === 0) return null;

  return (
    <div className="bg-[var(--secondary)] border-b-[3px] border-black overflow-hidden" data-testid="top-marquee">
      <div className="marquee-track py-2.5">
        {loop.map((t, i) => (
          <span key={i} className="font-display font-black uppercase text-base md:text-lg tracking-tight px-6 flex items-center gap-3">
            {t}
            {i % 2 === 0 ? <Star size={16} strokeWidth={3} fill="#0A0A0A" /> : <Sparkles size={16} strokeWidth={3} />}
          </span>
        ))}
      </div>
    </div>
  );
}
